import { MultiPurposeTitle } from "@/components/Atoms/Title";
import { MultiPurposeParagraph } from "@/components/Atoms/Paragraph";
import { resolvePageRelatedLink } from "@/lib/functions";
import { productConfShowcaseFields } from "@/lib/fragments";
import { ProductsGalleryCarousel } from "./ProductsGalleryCarousel";
import { ButtonMaster } from "@/components/Atoms/Buttons";
import { useRouter } from "next/router";

interface Props {
  title?: string;
  label?: string;
  titleColor?: { color?: { hex?: string; cssRgb?: string } };
  labelColor?: { color?: { hex?: string; cssRgb?: string } };
  backgroundColor?: { color?: { hex?: string; cssRgb?: string } };
  callToAction?: any;
  productsShowcase?: any[];
  portfolioSlug?: string;
}

export default function ProductsGallerySectionBrand({
  title,
  label,
  titleColor,
  labelColor,
  backgroundColor,
  callToAction,
  productsShowcase = [],
  portfolioSlug = "",
}: Props) {
  const { locale } = useRouter();

  if (!productsShowcase.length) return null;

  const pageRelated = callToAction;
  const ctaLink = pageRelated
    ? resolvePageRelatedLink(pageRelated, locale ?? "", portfolioSlug)
    : undefined;

  return (
    <section
      style={{ backgroundColor: backgroundColor?.color?.hex }}
      className="relative w-full overflow-hidden py-12 lg:py-16"
    >
      <div className="container mx-auto">
        {(label || title) && (
          <header className="mx-auto mb-10 flex max-w-3xl flex-col items-center gap-3 text-center">
            {label && (
              <MultiPurposeParagraph
                type="showcaseLabel"
                align="center"
                data={label}
                color={labelColor?.color ?? titleColor?.color}
              />
            )}
            {title && (
              <MultiPurposeTitle
                tag="h3"
                type="default"
                data={title}
                color={titleColor?.color}
                layout="center"
              />
            )}
          </header>
        )}

        <ProductsGalleryCarousel
          productsShowcase={productsShowcase}
          portfolioSlug={portfolioSlug}
          titleColor={titleColor}
          buttonStyle={pageRelated?.buttonStyle}
        />

        {pageRelated && ctaLink && (
          <div className="mt-12 flex justify-center">
            <ButtonMaster
              anim="slideLeft"
              type={pageRelated?.buttonStyle}
              cta={pageRelated?.typeColor?.color}
              color={pageRelated?.labelColor?.color}
              customIcon={pageRelated?.icon?.img}
              customColor={pageRelated?.iconColor?.color}
              link={ctaLink}
              target={
                pageRelated?.useExternalUrl || !pageRelated?.page
                  ? "_blank"
                  : "_self"
              }
            >
              {pageRelated?.buttonLabel?.label}
            </ButtonMaster>
          </div>
        )}
      </div>
    </section>
  );
}

export const fragment = `
  fragment ProductsGallerySectionBrandFragment on ProductsGallerySectionBrandRecord {
    __typename
    id
    name
    title
    label
    titleColor {
      color {
        hex
        cssRgb
      }
    }
    labelColor {
      color {
        hex
        cssRgb
      }
    }
    backgroundColor {
      color {
        hex
        cssRgb
      }
    }
    callToAction {
      ...pageRelatedFragment
    }
    productsShowcase {
      ${productConfShowcaseFields}
    }
  }
`;
